import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurMission from "./sections/OurMission";
import MembershipTiersOverview from "./sections/MembershipTiersOverview";
import Gallery from "./sections/Gallery";
import GetInTouch from "./sections/GetInTouch";
import WhatHappens from "./sections/WhatHappens";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurMission />
      <MembershipTiersOverview />
      <Gallery />
      <GetInTouch />
      <WhatHappens />
      <Footer />
    </div>;
}